import {
  loadObjectFromServer,
  getData,
  postData,
  putData,
  deleteData
} from "@/utils";
import authData from "@/data/authData.json";

export async function logout() {
  const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
  const response = await getData(APP_ROUTES.ACCOUNTS_LOGOUT);
  return response;
}

export async function getToken() {
  try {
    // curl -X POST -H "Cache-Control: no-cache" -H "Content-Type: application/x-www-form-urlencoded" "http://127.0.0.1:8000/o/token/" -d "client_id=6kff1AW1uMdOfOHuJqeevdhph9saUH89ue2Ub1Bm" -d "client_secret=CU0CWZHm6WS02mnG5YLBQC71NpBezMfjfTE9zkx5zxHU8yQaiwGRZHzU12BtMtlxgznHWUPm1z0fZFM4cz0yYCU2pjziGplWQgdGe1f4uwde9TScP2ItQukj27d7JUxS" -d "code=3hwXl24E1QUvJy0qFOBa7w3HXR7MHL" -d "code_verifier=6P9KYPF7CNDPWPDJPYA4IVJPE5LJRH3WC2E2OV6PO8ILVKL2U60FNPTGCQ" -d "redirect_uri=http://127.0.0.1:8000/noexist/callback" -d "grant_type=authorization_code"
    let payload = {}
    payload['code'] = localStorage.getItem("authorization_code");
    payload['code_verifier'] = localStorage.getItem("code_challenge");
    payload['client_id'] = `${process.env.VUE_APP_CLIENT_ID}`;
    payload['client_secret'] = `${process.env.VUE_APP_CLIENT_SECRET}`;
    payload['grant_type'] = "authorization_code";
    payload['redirect_uri'] = `${process.env.VUE_APP_REDIRECT_URL}`;
    // let apiUrl = "http://localhost:8000/o/token/";
    let apiUrl =`${process.env.VUE_APP_AUTHORIZATION_URL}`+"/o/token/"
    console.log("URL:",apiUrl);       
    let formData = "client_id="+payload['client_id'];
    formData = formData+"&client_secret="+payload['client_secret'];
    formData = formData+"&code="+payload['code'];
    formData = formData+"&code_verifier="+payload['code_verifier'];
    formData = formData+"&redirect_uri="+payload['redirect_uri'];
    formData = formData+"&grant_type="+payload['grant_type'];
    console.log("Form data:",formData);
    const response = await fetch(apiUrl, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      // mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      
      headers: {
          "Content-Type": "application/x-www-form-urlencoded",                    
      },
      // redirect: "follow", // manual, *follow, error
      // referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: formData // body data type must match "Content-Type" header    
    });
    if (response.status === 200 || response.status === 201) {
        
        return response.json(); // parses JSON response into native JavaScript objects
    } else {
        return null;
    }    
  } catch (e) {
    console.log("Error:",e);
    return null;
  }
}
